import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { Container, Header } from "./style";
import { IListarDadosLote } from "../../../../interfaces/IListarDadosLote";
import { CustomInput } from "components/CustomInput";
import { StatusItemLoteBloqueio } from "../StatusItemLoteBloqueio";
import { PrimaryButton } from "components/Button/style";
import { FaUndo } from "react-icons/fa";

interface IListarProps {
  idLote: number | null;
  dados: IListarDadosLote[];
  handleLimitChange: (e: number) => void;
  handlePageChange: (e: number) => void;
  totalRows: number;
  linhasPorPagina: number;
  pesquisaItensLote: string;
  setPesquisaItenslote: (pesquisa: string) => void;
  reprocessarItensComErro: (idLote: number | null) => any;
}

export function ListarDetalhesLote({
  idLote,
  dados,
  handleLimitChange,
  handlePageChange,
  totalRows,
  linhasPorPagina,
  pesquisaItensLote,
  setPesquisaItenslote,
  reprocessarItensComErro,
}: IListarProps) {
  const columns: IColum<IListarDadosLote>[] = [
    {
      name: "ID",
      selector: ({ idItemLoteBloqueioAdministrativo }: IListarDadosLote) =>
        idItemLoteBloqueioAdministrativo ?? "-",
    },
    {
      name: "Placa",
      selector: ({ placa }: IListarDadosLote) => placa ?? "-",
      width: "90px",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IListarDadosLote) => chassi ?? "-",
      width: "190px",
    },
    {
      name: "Renavam",
      selector: ({ renavam }: IListarDadosLote) => renavam ?? "-",
      width: "130px",
    },
    {
      name: "UF",
      selector: ({ uf }: IListarDadosLote) => uf ?? "-",
      width: "90px",
    },
    {
      name: "Status",
      selector: ({ status }: IListarDadosLote) =>
        status ? <StatusItemLoteBloqueio status={status} /> : "-",
      width: "150px",
    },
    {
      name: "Observação",
      selector: ({ observacao }: IListarDadosLote) => observacao ?? "-",
    },
  ];

  const onChangePesquisaItensLote = (pesquisa: string) => {
    setPesquisaItenslote(pesquisa);
  };

  return (
    <Container>
      <Header>
        <CustomInput
          value={pesquisaItensLote}
          onChange={(event) => onChangePesquisaItensLote(event.target.value)}
          style={{ maxWidth: 300 }}
          placeholder="Pesquisar"
        />
        <PrimaryButton
          buttonWidth="xl"
          buttonWidthTipo="px"
          type="button"
          onClick={() => reprocessarItensComErro(idLote)}
          outline
          variante="primary"
          style={{ fontSize: 12 }}
        >
          <FaUndo />
          Reprocessar
        </PrimaryButton>
      </Header>
      <Table
        keyField="id"
        totalRows={totalRows}
        pagination={true}
        columns={columns}
        data={dados}
        paginationRowsPerPageOptions={[30, 50, 100, 300]}
        loading={false}
        onChangeRowsPerPage={handleLimitChange}
        onChangePage={handlePageChange}
        noSubHeader
        possuiTooltip={false}
        rowsPerPage={linhasPorPagina}
        headerFixo
      />
    </Container>
  );
}
